





























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AxTitle extends Vue {
  @Prop({ type: String, required: true })
  title!: string;
}
